import React from 'react'    
import { Title, Container } from './timer.styled' 

export default function Timer({title, time}) {

    return <Container>
        <Title> {title}</Title>
        <Title><strong> {time} </strong></Title>
    </Container>
}